export default __webpack_public_path__ + "static/media/xcopy.6162a883.png";